import { useCalls } from "@/lib/calls";
import { useSession } from "@/lib/session";
import { Link } from "react-router-dom";

export default function LivePage() {
  const { live, hangup, lineStatus, freeLine, myCall } = useCalls();
  const { user } = useSession();

  return (
    <>
      <div className="top">
        <div>
          <p className="muted">Wallboard</p>
          <h1>Live calls</h1>
          <p className="muted">
            Ext {user?.extension || "—"} · Line <b>{lineStatus || "idle"}</b>
          </p>
        </div>
        <div className="top-actions">
          <Link className="btn" to="/app/softphone">
            Dialer
          </Link>
          {(myCall || lineStatus === "inuse" || lineStatus === "ringing") && (
            <button
              className="btn ghost"
              type="button"
              onClick={() => void (myCall ? hangup(myCall.uuid) : freeLine())}
            >
              End / free line
            </button>
          )}
        </div>
      </div>
      <section className="panel">
        <table className="table">
          <thead>
            <tr>
              <th>State</th>
              <th>From</th>
              <th>To</th>
              <th>Direction</th>
              <th>Agent</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            {live.length === 0 && (
              <tr>
                <td colSpan={6} className="muted">
                  No live legs. Place a click-to-call from the dialer.
                </td>
              </tr>
            )}
            {live.map((c) => (
              <tr key={c.uuid}>
                <td>
                  <span className={`pill ${c.state === "answered" ? "live" : "ring"}`}>
                    {c.state}
                  </span>
                </td>
                <td>{c.from}</td>
                <td>{c.to}</td>
                <td>{c.direction}</td>
                <td>{c.agentName || c.agentExtension || "—"}</td>
                <td>{String(c.duration)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </>
  );
}
